import { Link } from "react-router-dom";
import { BookOpen } from "lucide-react";

export default function Footer() {
  const openCookiePrefs = () => window.dispatchEvent(new Event("open-cookie-preferences"));
  return (
    <footer className="no-print border-t border-border bg-muted/40 mt-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
        <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-6">
          <div className="max-w-sm">
            <div className="flex items-center gap-2">
              <span className="w-8 h-8 rounded-lg bg-primary text-primary-foreground flex items-center justify-center"><BookOpen className="w-4 h-4" /></span>
              <span className="font-serif text-lg font-bold">Libri in Circolo</span>
            </div>
            <p className="text-sm text-muted-foreground mt-3">La comunità che fa girare i libri: dona o scambia gratuitamente i libri che non leggi più con altri cittadini della tua zona.</p>
          </div>
          <div className="flex flex-col sm:flex-row gap-8 text-sm">
            <div>
              <p className="font-semibold mb-2">Informazioni legali</p>
              <ul className="space-y-1.5">
                <li><Link to="/privacy" data-testid="footer-privacy" className="text-muted-foreground hover:text-primary transition-colors">Privacy Policy</Link></li>
                <li><Link to="/cookie" data-testid="footer-cookie" className="text-muted-foreground hover:text-primary transition-colors">Cookie Policy</Link></li>
                <li><button data-testid="footer-cookie-prefs" onClick={openCookiePrefs} className="text-muted-foreground hover:text-primary transition-colors">Preferenze cookie</button></li>
              </ul>
            </div>
          </div>
        </div>
        <div className="border-t border-border mt-8 pt-6 text-xs text-muted-foreground space-y-1">
          <p>Titolare: Marco Paparelli · Viale Regina Margherita, 46 – 00198 Roma · P.IVA 05042811009</p>
          <p>© {new Date().getFullYear()} Libri in Circolo · <Link to="/privacy" className="hover:text-primary underline">Privacy</Link> · <Link to="/cookie" className="hover:text-primary underline">Cookie</Link></p>
        </div>
      </div>
    </footer>
  );
}
